<app-larged-tuile
  icon="fa-kit fa-picto-altimeo-touch"
  [title]="'dashboard.clph' | translate"
  [buttons]="buttons"
  [status]="
    buttons[
      this.actionStack!.getValue('alSEtatPhDosingInProgress') &&
        this.actionStack!.getValue('alSEtatRxDosingInProgress')
    ].statusTitle!
  "
  [statusMode]="
    this.actionStack!.getValue('alSAlarm') === 1
      ? 'alarm'
      : buttons[
          this.actionStack!.getValue('alSEtatPhDosingInProgress') &&
            this.actionStack!.getValue('alSEtatRxDosingInProgress')
        ].status!
  "
  [selectItem]="this.actionStack!.getValue('alCEtatProduit')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.Altimeo_Control,
      'alCEtatProduit',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
